import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import ParticleField from './components/particles/ParticleField';

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <ParticleField count={2000} />
    </CanvasWrapper>
);

export default SplineScene;